import * as React from "react";

export function CircleCloseButton() {
	return (
		<span className="elm-bg-dd-blue-100 elm-w-10 elm-h-10 elm-flex elm-justify-center elm-items-center elm-pointer-events-none elm-rounded-full">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				height="24px"
				viewBox="0 0 24 24"
				width="24px"
				className="elm-block elm-fill-current elm-text-dd-blue-900"
			>
				<path d="M0 0h24v24H0z" fill="none" />
				<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
			</svg>
		</span>
	);
}
